import React from 'react';
import { useFormContext } from 'react-hook-form';
import { TextInput } from '@/components/form/TextInput.tsx';
import CheckboxInput from '@/components/form/CheckboxInput.tsx';
import ModalContent from '@/components/modal/ModalContent.tsx';
import ConsentTemplateSearchSelectRHF from '@/components/asyncSelect/entitySelects/ConsentTemplateSearchSelectRHF.tsx';
import { TourConsentFormData } from '@/features/dashboard/tourConsents/schemas/tourConsentSchema.ts';

const TourConsentForm = () => {
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext<TourConsentFormData>();

  return (
    <ModalContent>
      <div className="flex flex-col gap-4">
        <TextInput
          label="Nazwa wyświetlana"
          placeholder="Podaj nazwę..."
          register={register('displayName')}
          error={errors.displayName?.message}
          required
        />

        <ConsentTemplateSearchSelectRHF
          fieldPathName="consentTemplateId"
          control={control}
          label="Szablon zgody"
          required
          error={errors.consentTemplateId?.message}
          placeholder="Wyszukaj szablon zgody..."
        />

        <div className="flex flex-col gap-2">
          <CheckboxInput
            label="Wymagana"
            register={register('required')}
            hint="Uczestnik musi zaakceptować tę zgodę podczas rejestracji"
          />

          <CheckboxInput
            label="Wyślij dokument do klienta"
            register={register('shouldSendDocumentToClient')}
            hint="Dokument zgody zostanie wysłany do klienta po rejestracji"
          />
        </div>
      </div>
    </ModalContent>
  );
};

export default TourConsentForm;
